module.exports = __webpack_public_path__ + "static/media/tshirt3.2182c030.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Images/tshirt3.PNG
// module id = 79
// module chunks = 0